// New blog posts - August 2025
// Written from Patrik Germann's perspective

import { gpt5RewrittenContent } from './gpt5-rewritten'
import { claude41RewrittenContent } from './claude41-rewritten'

export const newBlogPosts = {
  'claude-4-1-opus-breakthrough': {
    id: 20,
    slug: 'claude-4-1-opus-breakthrough',
    title: {
      de: 'Claude 4.1 Opus: Mein Co-Developer seit Claude 3.7 - jetzt noch besser',
      en: 'Claude 4.1 Opus: My Co-Developer Since Claude 3.7 - Now Even Better'
    },
    excerpt: {
      de: 'Nach vier intensiven Monaten mit Claude 3.7, 4 und jetzt 4.1 kann ich sagen: Für Software-Entwicklung mit AI Agents ist Claude unschlagbar. Ein ehrlicher Erfahrungsbericht.',
      en: 'After four intensive months with Claude 3.7, 4, and now 4.1, I can say: For software development with AI agents, Claude is unbeatable. An honest experience report.'
    },
    content: claude41RewrittenContent,
    date: '2025-08-05',
    category: 'AI',
    readTime: { de: '10 Min. Lesezeit', en: '10 min read' }
  },

  'gpt-5-launch-swiss-perspective': {
    id: 21,
    slug: 'gpt-5-launch-swiss-perspective',
    title: {
      de: 'GPT-5 ist da: Beeindruckende Zahlen, aber Claude bleibt mein Co-Dev',
      en: 'GPT-5 Is Here: Impressive Numbers, But Claude Remains My Co-Dev'
    },
    excerpt: {
      de: 'Nach drei Tagen mit GPT-5: Eine nüchterne Betrachtung der Stärken und Schwächen aus Entwicklersicht.',
      en: 'After three days with GPT-5: A sober look at the strengths and weaknesses from a developer perspective.'
    },
    content: gpt5RewrittenContent,
    date: '2025-08-10',
    category: 'AI',
    readTime: { de: '10 Min. Lesezeit', en: '10 min read' }
  }
}
